import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getAsigneList';

export const getAsigneList = () => {
    return network.post(ENDPOINT).then((response) => response.data);
};
